export default import.meta.ROLLDOWN_FILE_URL_xYTJd31cnZPTzpy3_4yQcA